export enum AppPaths {
	EMAIL_CONFIRMATION = 'email-confirmation/:token',
	SUBMIT = 'submit',
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	ACCOUNT = 'account',
	COMPANY = 'company',

	CREATOR = 'creator',

	USER_NOTIFICATIONS = 'user-notifications',

	ORDERS = 'orders',
	OFFERS = 'offers',

	PRODUCT_TYPES = 'product-types',

	COMPLAINTS = 'complaints',
	FILES = 'files',
	CLIENTS = 'clients',
	CONTACTS = 'contacts',
}
